import { isEmpty } from 'ramda';
import * as RA from 'ramda-adjunct';
import { contactRelationLens, artistDetailsLens, artistFilesLens, relatedInfosPath, relatedInfosLens, relatedUsersLens, relatedCountriesLens, travelOptionsLens, artistCustomDataLens, bookingsLens, monthsLens, locationsLens, citiesLens, promotersLens, partnersLens, statusesLens, artistBookingLocationsLens, tracksLens, external_linksLens } from './state';
import { getter } from '../../../../utility/fp';


export const artistGetters = {
  artistDetailsFlag: (state) => state.artistDetailsFlag,

  selectedArtist: RA.viewOr({}, artistDetailsLens),
  selectedArtistLoading: state => isEmpty(RA.viewOr({}, artistDetailsLens, state)),

  // artistDetailsGridLayouts: (state) => state.artistDetailsGridLayouts,

  artistGridLayout0: (state) => state.artistGridLayout0,
  artistGridLayout1: (state) => state.artistGridLayout1,
  artistGridLayout2: (state) => state.artistGridLayout2,
  artistGridLayout3: (state) => state.artistGridLayout3,
  artistGridLayout4: (state) => state.artistGridLayout4,
  artistGridLayout5: (state) => state.artistGridLayout5,

  artistContactRelations: RA.viewOr([], contactRelationLens),
  artistFiles: RA.viewOr([], artistFilesLens),

  selectedArtistData: getter({
    contactRelations: RA.viewOr([], contactRelationLens),
    files: RA.viewOr([], artistFilesLens),
    relatedInfos: RA.viewOr([], relatedInfosLens),
    relatedUsers: RA.viewOr([], relatedUsersLens),
    relatedCountries: RA.viewOr([], relatedCountriesLens),
    travelOptions: RA.viewOr([], travelOptionsLens),
    customData: RA.viewOr([], artistCustomDataLens),
    bookings: RA.viewOr([], bookingsLens),
    statuses: RA.viewOr([], statusesLens),
    artistBookingLocations: RA.viewOr([], artistBookingLocationsLens),
    tracks: RA.viewOr([], tracksLens),
    external_links: RA.viewOr([], external_linksLens),

    months: RA.viewOr([], monthsLens),
    locations: RA.viewOr([], locationsLens),
    cities: RA.viewOr([], citiesLens),
    promoters: RA.viewOr([], promotersLens),
    partners: RA.viewOr([], partnersLens),
  }),
  artistDetails: (state) => state.artistDetails || [],
};